module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/dash-board/dashboard-exchangerate/dashboard-exchangerate.component.css
// module id = ./src/app/dash-board/dashboard-exchangerate/dashboard-exchangerate.component.css
// module chunks = main